"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useActions(query) {
  const { ...rest } = useElements("actions", query);
  return {
    actions: rest.items,
    ...rest
  };
}

export { useActions };
